import { Block, BlockSchema } from './Block.types';

import { BlockType, NavBarBlockConfigSchema } from './blockConfig/Types';

import { z } from 'zod';

export const NavBarBlockSchema = BlockSchema.extend({
  blockConfig: NavBarBlockConfigSchema,
});
export type NavBarBlock = z.infer<typeof NavBarBlockSchema>;

export function isNavBarBlock(block: Block): block is NavBarBlock {
  return block.blockConfig.type === BlockType.NavBar;
}
